import { type DocumentNode, type TypedDocumentNode } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { Dialog, DialogBody, DialogTitle } from '@/components/base/dialog'
import { Text } from '@/components/base/text'
import { Button } from '@/components/base/button'
import { BounceLoader } from 'react-spinners'

export interface Props<M> {
  id: string
  onSuccess: () => void
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  refetchQueries?: DocumentNode[]
  mutation: M
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DeleteDialog = <MutationDoc extends TypedDocumentNode<any, any>>({ id, onSuccess, open, setOpen, mutation, refetchQueries }: Props<MutationDoc>) => {
  const [deleteRecord, { loading }] = useMutation(mutation, { refetchQueries })

  const doDelete = () => {
    deleteRecord({ variables: { id } }).then(() => {
      onSuccess()
    })
  }

  return (
    <Dialog className="text-center" open={ open } size="sm" onClose={ setOpen }>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogBody>
        <div className="flex flex-col gap-6 items-center">
          <Text>We're sure you meant it, but it's always worth double checking!</Text>
          <div className="flex flex-row gap-3">
            <Button color="red" onClick={ doDelete }>
              Yes, delete it { loading && <BounceLoader color="lightgray" size={ 16 } /> }
            </Button>
            <Button color="dark/zinc" onClick={ () => setOpen(false) }>Not right now</Button>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  )
}
